export default __webpack_public_path__ + "static/media/orange.ebbac7f7.svg";